/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

const costOverviewContainerStyle = {
  table: {
    margin: "2rem auto",
    maxWidth: 400,
  },
  tableCell: {
    fontSize: "12px",
    padding: 0,
    borderBottom: "none",
  },
  tableCellHeader: {
    paddingTop: "1rem",
  },
  tableCellValue: {
    fontSize: "12px",
    padding: "0 !important",
    borderBottom: "none",
    textAlign: "right",
  },
  underlined: {
    borderBottom: "1px solid #333333",
  },
  doubleUnderlinedRow: {
    height: "3px",
    padding: 0,
  },
  doubleUnderlinedCell: {
    height: "3px",
    borderBottom: "1px solid #333333",
    borderTop: "1px solid #333333",
    padding: 0,
  },
  tableRow: {
    height: "24px",
  },
  disclaimer: {
    fontSize: "10px",
    lineHeight: "1rem",
  },
  total: {
    fontSize: "12px",
    fontWeight: 500,
    color: "primary.main",
  },
  primary: {
    fontSize: "12px",
    fontWeight: 500,
    color: "primary.main",
  },
};

export default costOverviewContainerStyle;
